module.exports = __webpack_public_path__ + "static/media/sync-icon-selected.2ad14bf2.png";